import { useState } from 'react';
import { useLocalization } from '@/hooks/useLocalization';
import { useLead } from '@/hooks/useLead';
import { useChat } from '@/hooks/useChat';
import BotMessage from '@/components/ChatMessage/BotMessage';
import OptionButton from '@/components/OptionButton/OptionButton';
import formStyles from '@/styles/forms.module.scss';

const MAX_LENGTH = 500;

export default function EmailInquiryScreen() {
  const { t } = useLocalization();
  const { leadData, setMessage } = useLead();
  const { submitEmailInquiry } = useChat();
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const message = String(leadData.message || '');
  const length = message.trim().length;

  const handleSubmit = async () => {
    if (length < 3) {
      setError(t('emailInquiry.errorRequired'));
      return;
    }

    setError(null);
    setIsSubmitting(true);
    try {
      await submitEmailInquiry();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <BotMessage text={t('emailInquiry.message')}>
      <div className={formStyles.emailForm}>
        <label className={formStyles.label} htmlFor="ibc-email-inquiry">
          {t('emailInquiry.label')}
        </label>
        <textarea
          id="ibc-email-inquiry"
          className={[
            formStyles.textarea,
            error ? formStyles.error : '',
          ].filter(Boolean).join(' ')}
          placeholder={t('emailInquiry.placeholder')}
          value={message}
          maxLength={MAX_LENGTH}
          rows={4}
          onChange={(e) => {
            setMessage(e.target.value);
            if (error) setError(null);
          }}
        />
        <div className={formStyles.textareaMeta}>
          {error ? (
            <span className={formStyles.errorMsg}>{error}</span>
          ) : (
            <span className={formStyles.textareaHint}>{t('emailInquiry.hint')}</span>
          )}
          <span className={formStyles.textareaCount}>
            {message.length}/{MAX_LENGTH}
          </span>
        </div>
        <OptionButton
          variant="primary"
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? t('emailInquiry.sending') : t('emailInquiry.submit')}
        </OptionButton>
      </div>
    </BotMessage>
  );
}
